import _ from "lodash";

/*
* Делаем элемент в массиве с нужной нам ролю первым. Например, что бы капитан всегда был первым в списке
*/
export const makeElFirstInArrByRole = (arr, role) => {
    arr.unshift(...arr.splice(_.findIndex(arr, item => item.role === role),1))
}